import { Check, Sparkles } from 'lucide-react';
import { getNestedValue } from '../utils';
import { cn } from '@/lib/utils';

/**
 * AI Suggestion Status Badge - shows only the status (loading/applied) in the label area
 * This is separate from the apply button to avoid redundancy
 */
export function AISuggestionStatusBadge({
  suggestionKey,
  enrichmentContext,
  currentValue,
  className,
}: {
  suggestionKey: string;
  enrichmentContext?: Record<string, unknown>;
  currentValue: unknown;
  className?: string;
}) {
  if (!suggestionKey) return null;

  // Loading state
  if (!enrichmentContext || Object.keys(enrichmentContext).length === 0) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-[hsl(var(--globe-grey))]/10 text-globe-grey',
          className
        )}
        title="AI suggestion will appear after completing the previous step"
      >
        <Sparkles className="h-3 w-3 opacity-50" />
        <span className="opacity-70">AI</span>
      </span>
    );
  }

  const suggestedValue = getNestedValue(enrichmentContext, suggestionKey);

  if (suggestedValue === undefined || suggestedValue === null) {
    return null;
  }

  const suggestedStr = String(suggestedValue);
  const currentStr =
    currentValue !== undefined && currentValue !== null ? String(currentValue) : '';

  // Applied state
  if (suggestedStr === currentStr) {
    return (
      <span
        className={cn(
          'inline-flex flex-row  items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-emerald-50 text-emerald-600 border border-emerald-200 text-nowrap',
          className
        )}
      >
        <Check className="h-3 w-3" />
        <span>
          <span className="hidden md:inline">Standard</span> applied
        </span>
      </span>
    );
  }

  // No badge shown when suggestion is available but not applied (user will see "Apply Standards" banner)
  return null;
}
